import React from 'react';
function Design({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M12.45 8.206l-5.187-5.21L3 7.259l5.21 5.195M19.105 8.206L8.21 19.099l-4.735 1.423 1.447-4.766L15.817 4.861m3.288 3.344l-3.288-3.344m3.288 3.344l1.868-1.867-3.289-3.343-1.867 1.866M15.386 18.572l1.622-1.615M7.23 10.429l1.787-1.78m4.586 8.17l1.33-1.321M5.367 8.563L6.68 7.26M12 15.498l5.12 5.336L21 16.957l-5.14-5.311L12 15.498zM5.368 16.259l2.369 2.368"
      />
    </svg>
  );
}

export default Design;
